import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

const walletSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getWallet: build.query<any, void>({
      query: () => `${urlConfig.walletsBaseUrl}/wallets`,
      providesTags: ['Wallet'],
    }),
  }),
})

export const { useGetWalletQuery } = walletSlice
